import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { InsuranceAdoptionStatus, Resident } from "@graphql/api";

import CoverageItem from "./CoverageItem";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
  switchToDocuments(): void;
}

export default function CoveragesTabContent({
  isLoading,
  resident,
  switchToDocuments,
}: Props) {
  if (!resident?.coverages && isLoading) {
    return <Skeleton width="100%" height={76} variant="rectangular" />;
  }

  if (!resident.coverages.length) {
    return (
      <Typography variant="subtitle1">
        Resident has no coverages assigned.
      </Typography>
    );
  }

  return (
    <Stack direction="column" spacing={2}>
      {resident?.coverages?.map((coverage) => (
        <CoverageItem
          key={coverage.id}
          coverage={coverage}
          isResidentExcluded={
            resident.insuranceAdoption.status ===
            InsuranceAdoptionStatus.Excluded
          }
          switchToDocuments={switchToDocuments}
        />
      ))}
    </Stack>
  );
}
